import React from 'react';
import { CFooter } from '@coreui/react';

const TheFooter = () => (
  <CFooter fixed={false} />
);
//
export default React.memo(TheFooter);
